"use strict";
/* globals module */
/**
 * @module roleClient
 * @description  Role Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `roleClient` uses `roleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var RoleClient = /** @class */ (function () {
    function RoleClient(roleBatchClient, roleRoute, apiClient) {
        this.roleBatchClient = roleBatchClient;
        this.roleRoute = roleRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(RoleClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `roleRoute`.
         * @method
         * @example roleClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.roleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleClient.prototype, "batch", {
        /**
         * Provides direct access to `roleBatchClient`.
         * @method
         **/
        get: function () {
            return this.roleBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of role resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has beend performed.
     * @example roleClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified role resource.
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example roleClient.get('<role-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    RoleClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.roleRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a role.
     * @method
     * @param data A role object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create action has beend performed.
     * @example roleClient.create({
                    description : '<description>',
                    name : '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update role action has been performed; this action updates a role. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A role object used to update specified role resource.
     * @returns A promise that is resolved once the update role action has been performed.
     * @example // role is a resource previously fetched using get action.
                    role.name = '<new-name>';
                    roleClient.update(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove role action has been performed. This action will remove a role from the system, if completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('delete').href; ```
     * @param data A role object used to delete specified role resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Role is a resource previously fetched using get action.
                    roleClient.remove(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    RoleClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RoleBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RoleBatchClient !== "undefined" && _1.RoleBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.RoleRoute !== "undefined" && _1.RoleRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], RoleClient);
    return RoleClient;
}());
exports.RoleClient = RoleClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 
